// extracted by mini-css-extract-plugin
export default {"authLinkTo":"AuthLinkTo_authLinkTo__LR+yS"};